import type { CSSProperties } from 'react';
import { styled, css } from 'styled-components';

export interface StyledInputProps {
  width?: CSSProperties['width'];
  $minWidth?: number;
  $withIcon?: boolean;
}

export const StyledInput = styled.input<StyledInputProps>`
  ${({ theme }) => theme.typography.textMedium}
  z-index: 2;
  width: ${({ width }) => width || '100%'};
  ${({ $minWidth }) =>
    $minWidth &&
    css`
      min-width: ${$minWidth}px;
    `}
  height: 36px;
  padding: 8px ${({ $withIcon }) => ($withIcon ? '36px' : '12px')} 8px 12px;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.black_1};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey70_1} !important;
  }

  &[disabled] {
    color: ${({ theme }) => theme.colors.grey100_2};
    cursor: not-allowed;

    &::placeholder {
      color: ${({ theme }) => theme.colors.grey100_2!} !important;
    }
  }

  &:focus {
    outline: none;
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  &[data-com-onepassword-filled],
  &:-webkit-autofill::first-line,
  &:-webkit-autofill {
    background-color: transparent;
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.grey00_7} inset;
    -webkit-text-fill-color: inherit;
    color: ${({ theme }) => theme.colors.black_1};
    font-family: 'CircularXXWeb', sans-serif;
  }
`;
